/**
 * External dependencies
 */
import { combineReducers } from 'redux';
/**
 * Internal dependencies
 */

import { createReducer } from 'state/utils';
import {
    CURRENT_WEB_RECEIVE,
    CURRENT_WEB_REQUEST,
    CURRENT_WEB_REQUEST_SUCCESS,
    CURRENT_WEB_REQUEST_FAILURE,
} from 'state/action-types';

export const requesting = createReducer(false, {
    [CURRENT_WEB_REQUEST]: () => true,
    [CURRENT_WEB_REQUEST_SUCCESS]: () => false,
    [CURRENT_WEB_REQUEST_FAILURE]: () => false,
});

const items = createReducer(null, {
    [CURRENT_WEB_RECEIVE]: (state, action) => action.payload.web,
});

export const error = createReducer(false, {
    [CURRENT_WEB_REQUEST]: () => false,
    [CURRENT_WEB_REQUEST_SUCCESS]: () => false,
    [CURRENT_WEB_REQUEST_FAILURE]: () => true,
});



export default combineReducers({
    items,
    requesting,
    error
});
